<template>
	<component
		:is="linkComponent"
		:href="blok.url.cached_url"
		:target="blok.url.target"
		:aria-label="blok.image.alt || 'Zjistit více'"
		class="relative block w-full overflow-hidden aspect-[16/6]"
		@focus="handleItemFocus"
		@blur="handleItemBlur"
	>
		<NuxtImg
			v-if="blok.image?.filename"
			provider="storyblok"
			:width="imgSizes.width"
			:height="imgSizes.height"
			:modifiers="storyblokFocusModifiers(blok.image.focus)"
			:src="blok.image.filename"
			:alt="blok.image.alt || ''"
			sizes="min:100vw xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:1664px inf:1664px"
			class="w-full h-full object-cover cover-parent"
			preload
		/>
	</component>
</template>

<script setup lang="ts">
	import type {HomepageIntroItemStoryblok} from '~/storyblok/types';
	import useTailwindBreakpoints from '~/composables/useTailwindBreakpoints';

	interface Props {
		blok: HomepageIntroItemStoryblok
	}

	type Emits = {
		(e: 'itemFocus'): void;
		(e: 'itemBlur'): void;
	};

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();

	const breakpoints = useTailwindBreakpoints();
	const isTablet = breakpoints.greaterOrEqual('md');
	const isDesktop = breakpoints.greaterOrEqual('lg');
	const isFullHD = breakpoints.greaterOrEqual('xxl');

	const imgSizes = computed(() => {
		switch (true) {
			case isFullHD.value:
				return {width: 2560, height: 1024};
			case isDesktop.value:
				return {width: 1440, height: 576};
			case isTablet.value:
				return {width: 1200, height: 480};
			default:
				return {width: 900, height: 360};
		}
	});

	const linkComponent = computed(() => {
		if (props.blok.url.linktype === 'story') {
			return resolveComponent('AbsoluteInternalLink');
		}
		return 'a';
	});

	function handleItemFocus() {
		emit('itemFocus');
	}

	function handleItemBlur() {
		emit('itemBlur');
	}
</script>
